/**
 * Whether a static picture exists, asked with HEAD so the answer does not wait for the file itself.
 *
 * `fetch` rather than services/api: this is a file off the site root, not the API — no session, no
 * CSRF header, no problem+json to parse. Only an image counts as found: deployed, nginx answers a
 * path it has no file for with the SPA's index.html and a 200, which is not a picture. A request
 * that fails or takes longer than `timeoutMs` counts as missing — the page is waiting on the answer,
 * and a story with no picture is a better outcome than a story that never appears.
 */
export async function imageExists(url: string, timeoutMs = 1500): Promise<boolean> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(url, { method: 'HEAD', signal: controller.signal });
    return response.ok && (response.headers.get('content-type') ?? '').startsWith('image/');
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}
